export const images = [
    require('../../assets/images/logo.png'),
    require('../../assets/images/krish.png'),
    require('../../assets/images/kingfisher.png'),
    require('../../assets/images/Mahajbeen.png'),
     require('../../assets/images/ruchi.png'),
     require('../../assets/images/gold.png'),
  ]